import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const SESSION_KEY = "page_analytics_session_id";

function getSessionId(): string {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

function getDeviceType(): string {
  const width = window.innerWidth;
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
}

export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef<string>("");

  useEffect(() => {
    const path = location.pathname;
    // Avoid duplicate tracking for the same path
    if (path === lastPath.current) return;
    lastPath.current = path;

    const sessionId = getSessionId();
    const deviceType = getDeviceType();

    // Fire and forget — don't await, don't block rendering
    supabase
      .from("page_analytics")
      .insert({
        session_id: sessionId,
        page_path: path,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent,
        device_type: deviceType,
      })
      .then(() => {
        // Atomic upsert + increment via SECURITY DEFINER RPC
        supabase.rpc("track_page_session", {
          p_session_id: sessionId,
          p_device_type: deviceType,
          p_referrer: document.referrer || null,
        }).then();
      });
  }, [location.pathname]);
}
